import { render, staticRenderFns } from "./ResellerServiceViewLogs.vue?vue&type=template&id=12850fb8"
import script from "./ResellerServiceViewLogs.vue?vue&type=script&lang=js"
export * from "./ResellerServiceViewLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports